import { type TokenData, TokenMetricNames } from "../models/tokenDO.models";
import { i18n } from "../../internationalize/i18n.service";
// import { tokenDataService } from "../services/tokenData.service";

import '../style/tokenData.css'
import type { TokenDataService } from "../services/tokenData.service";
import { buildTokenData, getMetricColor } from "../helpers/tokenData.helpers";

export class TokenDataContainer extends HTMLElement {
    constructor(private tokenDataService: TokenDataService = window.tbwServices.tokenDataService) {
        super()
        this.classList.add('token-data-container')
    }

    connectedCallback() {
        const tokenSlug = this.getAttribute('data-token-slug')
        if (!tokenSlug) { throw new Error('Token slug not found') }

        this.load()
    }

    async load() {
        const tokenSlug = this.getAttribute('data-token-slug')
        if (!tokenSlug) { throw new Error('Token slug not found') }

        const tokenData = await this.tokenDataService.getTokenData(tokenSlug)
        if (tokenData.length === 0) { throw new Error('No token data found') }

        this.setValues(this, buildTokenData(tokenData[0]))
        this.style.display = 'flex'
    }

    setValues(container: HTMLElement, tokenDataItem: TokenData) {
        for (const [metric, value] of Object.entries(tokenDataItem)) {
            if (value === null) continue

            const dataBox = document.createElement('div')
            const metricName = i18n.getLanguage() === 'fr' ? TokenMetricNames[metric as keyof typeof TokenMetricNames].french : TokenMetricNames[metric as keyof typeof TokenMetricNames].english
            dataBox.className = 'token-data-box'
            dataBox.innerHTML = `
                <div id='metric' class='caption1'>${metricName}</div>
                <div id='value' class='headline-5'>${value}</div>`

            if (metric === 'percent_change_24h') {
                const color = getMetricColor(tokenDataItem, metric)
                const value: HTMLDivElement | null = dataBox.querySelector('#value')

                if (!value || !value.style) { continue }
                value.style.color = color
            }

            container.appendChild(dataBox)
        }
    }
}